import { useCallback } from 'react';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';
import customersByLang from '../../../locales/customers.json';
import { LANGUAGES } from '../../../constants/appConstants';
import { mapRiskComplianceError } from './riskComplianceConstants';

export const useRiskComplianceErrorMessage = () => {
  const { customers: c, language } = useTranslatedMessages();
  const labels = c?.riskCompliance?.errors ?? customersByLang[language ?? LANGUAGES.EN]?.riskCompliance?.errors;

  return useCallback((error) => mapRiskComplianceError(error, labels), [labels]);
};
